export default __webpack_public_path__ + "img/all_pocket.67087c75.jpg";